import React from "react"
import "../style.css"
import PropTypes from "prop-types"
import Header from "./header"
import Footer from "./footer/"
import LayoutStyles from "./layout.module.css"
import { Helmet } from "react-helmet"
import Yoast from "../yoast"
import { Breadcrumbs } from "./breadcrumbs"
const Layout = ({
	children,
	articleId,
	articleClassName,
	ancestors,
	actionsClassName,
	actionsWidgets,
	...props
}) => {
	return (

		<div className={LayoutStyles.wrapper}>
			<Helmet bodyAttributes={{ class: "wp-embed-responsive" }}>
				<script
					id="Cookiebot"
					src="https://consent.cookiebot.com/uc.js"
					data-cbid="320a5ad6-37b0-4609-a232-2e6ab3de79d6"
					data-blockingmode="auto"
					type="text/javascript"
					async
				/>
				<link rel="stylesheet" type="text/css" href="/wpstyles.css" />
				<link rel="stylesheet" type="text/css" href="/core_wpstyles.min.css" />
			</Helmet>
			{props.context && props.context.yoast_meta && (
				<Yoast yoast={props.context.yoast_meta} location={props.location} />
			)}
			<Header className={LayoutStyles.header} />
			<section id="primary" className="content-area">
				<main id="main" className="site-main">
					<div className={` ${actionsClassName ? actionsClassName : ''} `}>
						<div className="container flex justify-between">
							{ancestors && <Breadcrumbs ancestors={ancestors} />}
							{!!actionsWidgets && <>{actionsWidgets}</>}
						</div>
					</div>

					<article id={articleId} className={articleClassName}>
						{children}
					</article>
				</main>
			</section>
			<Footer />
		</div >
	)
}

Layout.propTypes = {
	children: PropTypes.node.isRequired,
	articleId: PropTypes.string,
	articleClassName: PropTypes.string,
	actionsClassName: PropTypes.string,
	actionsWidgets: PropTypes.any
}

export default Layout
